import React, { ReactNode } from 'react'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Space, Tag } from 'src/antd'

import NONE from 'src/new-components/event-log-kit/cell/components/None'

import { TX_FROM, TX_TO } from '../../transifex'

export type TFromToProps = {
  from: ReactNode
  to: ReactNode
  icon?: ReactNode
  short?: boolean
  /** default to true
   * Will break to new line.
   */
  wrap?: boolean
  wrapChildInTag?: boolean
}

export const FromTo = ({
  from,
  to,
  icon = <ArrowRightOutlined style={{ color: 'gray' }} />,
  short,
  wrap = true,
  wrapChildInTag,
}: TFromToProps) => {
  const fromValue = from || NONE
  const toValue = to || NONE

  const shouldWrapFrom = wrapChildInTag && from
  const shouldWrapTo = wrapChildInTag && to

  return (
    <Space size={6} wrap={wrap}>
      {!short && fromValue && TX_FROM}
      {shouldWrapFrom ? <Tag>{fromValue}</Tag> : fromValue}
      {fromValue && toValue && icon} {toValue && !short && TX_TO}
      {shouldWrapTo ? <Tag>{toValue}</Tag> : toValue}
    </Space>
  )
}
